import * as React from 'react';
import { Formik } from 'formik';

import { Col, DataWell } from 'common/components/layout-styles';
import type { CreateProcedurePayloadType } from 'security-app/hooks/api/eventProceduresAPI.types';

import { INIT_EVENT_PROCEDURE, validations } from './utils';
import NewButtons from './NewButtons';
import FormButtons from './FormButtons';
import FormBase from './FormBase';
import useFormActions from './useFormActions';

import EventProcedureLibraryForm from '../EventProcedureLibraryForm';

type Props = {
  eventProcedure?: CreateProcedurePayloadType;
  onSave?: (eventProcedureId: string) => void;
  onDelete?: (eventProcedureId: string) => void;
  onCancel?: () => void;
};

function Form({
  eventProcedure = INIT_EVENT_PROCEDURE,
  onSave = undefined,
  onDelete = undefined,
  onCancel = undefined,
}: Props) {
  const { handleSubmit, saving } = useFormActions();
  const [show, setShow] = React.useState<string | undefined>(eventProcedure.id ? 'new' : undefined);

  const onSubmit = React.useCallback(
    (inValues: CreateProcedurePayloadType) => {
      handleSubmit({ inValues, eventProcedureId: eventProcedure?.id, cb: onSave });
    },
    [eventProcedure?.id, handleSubmit, onSave],
  );

  const handleCancel = React.useCallback(() => {
    setShow(undefined);
    onCancel?.();
  }, [onCancel]);

  if (show === 'new') {
    return (
      <Formik initialValues={eventProcedure} validate={validations} onSubmit={onSubmit}>
        <DataWell>
          <Col>
            <FormBase />
            <FormButtons
              isEdit={!!eventProcedure.id}
              onRemove={() => onDelete?.(eventProcedure.id)}
              saving={saving}
              onCancel={onCancel}
            />
          </Col>
        </DataWell>
      </Formik>
    );
  }

  if (show === 'library') {
    return <EventProcedureLibraryForm onClose={() => setShow(undefined)} onAdd={(id) => onSave(id)} />;
  }

  return (
    <NewButtons
      onCancel={handleCancel}
      onFromLibrary={() => setShow('library')}
      onNewEventProcedure={() => setShow('new')}
    />
  );
}

export default Form;
